import { render } from "./PantryDetailGraphView.vue?vue&type=template&id=00fb4e5a&ts=true"
import script from "./PantryDetailGraphView.vue?vue&type=script&lang=ts"
export * from "./PantryDetailGraphView.vue?vue&type=script&lang=ts"

import "./PantryDetailGraphView.vue?vue&type=style&index=0&id=00fb4e5a&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__